










import Vue from "vue";
import Component from "vue-class-component";
import { LeadService } from "@/services/lead.service";
import { Prop, Watch } from "vue-property-decorator";
import { required } from "@/shared/validators";

interface ComboItem {
  text: string;
  value: string | null;
}

@Component
export default class ComboResponsavelLead extends Vue {
  @Prop() readonly value!: string | null;
  loading = false;
  responsavelLead: ComboItem | null = null;
  itemsResponsavelLead: ComboItem[] = [];

  rules = {
    responsavelLead: [required()]
  };

  @Watch("value")
  onValueChange(val: string | null) {
    this.responsavelLead = this.itemsResponsavelLead.find((x) => x.value == val) ?? null;
  }

  @Watch("responsavelLead")
  onChangeTipo(val: ComboItem) {
    this.$emit("input", val?.value);
  }

  async fetchResponsavelLead() {
    this.loading = true;
    const res = await LeadService.listarResponsaveis();
    this.itemsResponsavelLead = res.map((x) => ({
      text: x.nome,
      value: "" + x.idUsuario,
    }));

    this.itemsResponsavelLead.unshift({ text: "", value: null });

    if (this.value) {
      this.responsavelLead = this.itemsResponsavelLead.find((x) => x.value == this.value) || null;
    }

    this.loading = false;
  }

  mounted() {
    this.fetchResponsavelLead();
  }
}
